module.exports = __webpack_public_path__ + "img/weixin.a8c3eb7e.png";